import SignaturePad from "signature_pad"

// The markup to make it work:
// <div x-data="signature()" id="canvasWrapper" class="pipe-signature">
//   <canvas></canvas>
// </div>

export default () => {
  return {
    signaturePad: null,
    canvas: null,
    isSigned: false,

    init() {
      this.store = Alpine.store("data")

      // Wait until Alpine has rendered the DOM
      this.$nextTick(() => {
        const wrapper = document.querySelector("#canvasWrapper")
        this.canvas = document.querySelector("#canvasWrapper canvas")

        this.signaturePad = new SignaturePad(this.canvas, {
          // It's Necessary to use an opaque color when saving image as JPEG
          // this option can be omitted if only saving as PNG or SVG
          backgroundColor: "rgb(255, 255, 255)",
        })

        if (this.isEmpty()) {
          this.store.values.isSignatureSigned = false
          this.isSigned = false
        }

        this.signaturePad.addEventListener("endStroke", () => {
          this.store.values.isSignatureSigned = true
          this.isSigned = true
        })

        // Adjust canvas coordinate space taking into account pixel ratio,
        // to make it look crisp on mobile devices.
        // This also causes canvas to be cleared.
        const resizeCanvas = () => {
          // When zoomed out to less than 100%, for some very strange reason,
          // some browsers report devicePixelRatio as less than 1
          // and only part of the canvas is cleared then.
          const ratio = Math.max(window.devicePixelRatio || 1, 1)

          // Save current data
          const data = this.signaturePad.toData()
          
          // Resize canvas
          // This part causes the canvas to be 
          // cleared automatically by the browser
          this.canvas.width = wrapper.offsetWidth * ratio
          this.canvas.height = wrapper.offsetHeight * ratio
          this.canvas.getContext("2d").scale(ratio, ratio)
          
          // Restore drawing after resize/clearing
          this.signaturePad.fromData(data)
        }

        // Initial resize
        resizeCanvas()

        // Listen to container size changes
        if ("ResizeObserver" in window) {
          const observer = new ResizeObserver(() => {
            requestAnimationFrame(resizeCanvas)
          })
          observer.observe(wrapper)
        }
        
        // Fallback and device orientation change coverage
        window.addEventListener("resize", resizeCanvas)
        
      })
    },

    // Basic action which may be useful in future
    clear() {
      this.signaturePad?.clear()
      this.isSigned = false
    },

    save() {
      return this.signaturePad?.toDataURL("image/png")
    },

    isEmpty() {
      return this.signaturePad?.isEmpty()
    },
  }
}
